import CONF from '@/Config.js';
import axios from 'axios';

export default {
    fetchPolicy: function(policyId)
    {
        return axios({
            method: 'get',           
            headers: {
                'Access-Control-Allow-Origin': "*"
            }, 
            url: CONF.FETCH_POLICY.replace("${policyId}", policyId)
        })
    },
    fetchAnnouncement: function(announcementId)
    {
        return axios({
            method: 'get',           
            url: CONF.FETCH_ANNOUNCEMENT
        })
    },
    fetchCategories: function()
    {
        return axios({
            method: 'get',          
            headers: {
                'Access-Control-Allow-Origin': '*'
            }, 
            url: CONF.FETCH_CATEGORIES
        })
    },
    initializeCardInfo: function(card)
    {
        return axios({
            method: 'post',           
            url: CONF.FORCE_CARD_CREATED,
            data: card
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/Api.js